import React from 'react';
import {localization} from '../../Frames/localization'
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
    root: {
      width: '100%',
      overflowX: 'auto',
    },
    });
    function Data(props)
    {
     var rows = 
        props.data.subAccounts.map(item => (
          createData(item.externalCardCode, item.name, item.recallLimitPerDay, item.recallLimitPerWeek, item.recallLimitPerMonth )
        ))
    
      return rows;
    }
  function createData(card, purse, day, week, month) {
    return { card, purse, day, week, month };
  }
  
  export default function SimpleTable(props) {
    const classes = useStyles();
    const rows = Data(props)
    var tr = {
      Card: localization.GetTranslate('Limits.Card'),
      Purse: localization.GetTranslate('Limits.Purse'),
      Daily: localization.GetTranslate('Limits.Daily'),
      Weekly: localization.GetTranslate('Limits.Weekly'),
      Monthly: localization.GetTranslate('Limits.Monthly'),
    }
    return (
        <div className={props.className}>
                <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                    <TableCell align="center">{tr.Card}</TableCell>
                    <TableCell align="center">{tr.Purse}</TableCell>
                    <TableCell align="center">{tr.Daily}</TableCell>
                    <TableCell align="center">{tr.Weekly}</TableCell>
                    <TableCell align="center">{tr.Monthly}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows &&
                    rows.map(row => (
                    <TableRow key={row.card}>
                        <TableCell component="th" scope="row">{row.card}</TableCell>
                        <TableCell align="center">{row.purse}</TableCell>
                        <TableCell align="center">{row.day}</TableCell>
                        <TableCell align="center">{row.week}</TableCell>
                        <TableCell align="center">{row.month}</TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
      </div>
    );
  }